/// <reference path="../../../../../../typings/index.d.ts" />
module Meevo.Plugins.RatingsControlPanel {

    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    export class RatingsDetailedViewController implements ng.IComponentController {
        static $inject = [
            '$scope',
            'meevo.AppSettings',
            'meevo.components.common.IdentityService',
            'meevo.components.common.SecurityService',
            'meevo.components.modal.ModalService',
        ];

        public items: IRating[];
        public clientSecurity: boolean;
        public commentSecurity: boolean;
        public isShowSelectColumn: boolean;
        public showClientDetail: ({clientId: string}) => void;
        public switchDeleted: ({rating: Rating}) => void;
        public saveReply: ({rating: Rating}) => void;

        public editAllSecurity: Model.SecurityItem;
        public editMySecurity: Model.SecurityItem;
        public securityKeys = Meevo.Components.Common.SecurityKeys;
        public securityParts = Meevo.Components.Common.SecurityParts;
        public selectAllModel: boolean;

        public get objectStateEnum(): typeof ObjectStateEnum {
            return ObjectStateEnum;
        }

        constructor(
            private $scope: ng.IScope,
            private appSettings: Meevo.Components.Common.IAppSettings,
            private identityService: Meevo.Components.Common.IIdentityService,
            private securityService: Meevo.Components.Common.ISecurityService,
            protected modalService: Meevo.Components.Modal.IModalService,
        ) {
            this.securityService
                .checkSecurityItem(this.securityKeys.MANAGEMENT_RATINGSCONTROLPANEL_ACTION_EDITALLRATINGS + this.securityParts.KEY_PART_WRITE)
                .then((item) => {
                    this.editAllSecurity = item;
                });

            this.securityService
                .checkSecurityItem(this.securityKeys.MANAGEMENT_RATINGSCONTROLPANEL_ACTION_EDITMYRATINGS + this.securityParts.KEY_PART_WRITE)
                .then((item) => {
                    this.editMySecurity = item;
                });
        }

        public isMine(item: IRating): boolean {
            return item.employee_User_TId === this.identityService.current().userId.toString();
        }

        public hideDelete(item: IRating): boolean {
            if (this.isMine(item)) {
                return this.editAllSecurity.securityAccess === Model.SecurityAccessEnum.Hide && this.editMySecurity.securityAccess === Model.SecurityAccessEnum.Hide;
            }
            return this.editAllSecurity.securityAccess === Model.SecurityAccessEnum.Hide;
        }

        public $onChanges() {
            this.checkAllSelected();
        }

        public selectAll() {
            this.items.forEach(item => {
                if (!item.isDeleted) {
                    item.isSelected = this.selectAllModel;
                }
            })
        }

        public checkAllSelected() {
            this.selectAllModel = true;
            this.items.forEach(item => {
                if (!item.isSelected) {
                    this.selectAllModel = false;
                    return;
                }
            })
        }

        public goToClient(clientId: string) {
            this.$scope.$emit(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: this.appSettings.ROUTE_NAMES.client,
                stateParams: {
                    callback: null,
                    callbackState: null,
                    targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                    actionState: Meevo.Model.MaintenanceFormState.Readonly,
                    id: clientId
                },
            });
        }

        public deleteItem(item: IRating) {
            let key = '';

            if (this.isMine(item)) {
                key = this.securityKeys.MANAGEMENT_RATINGSCONTROLPANEL_ACTION_EDITMYRATINGS + this.securityParts.KEY_PART_WRITE;
            } else {
                key = this.securityKeys.MANAGEMENT_RATINGSCONTROLPANEL_ACTION_EDITALLRATINGS + this.securityParts.KEY_PART_WRITE;
            }
            this.securityService
                .checkSecurityItemWithElevation(key, true)
                .then(() => {
                    this.switchDeleted({rating: item});
                });
        }

        public reply(item: IRating): void {
            const modalOptions: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/ratingsControlPanel/components/reply-modal/reply-modal.template.html',
                controller: 'meevo.plugins.ratingsControlPanel.ReplyModalController',
                controllerAs: 'vm',
                bindToController: true,
                locals: {
                    employeeLastName: item.employeeLastName,
                    employeeFirstName: item.employeeFirstName,
                    serviceShortcut: item.shortcut,
                    serviceDisplayName: item.displayName,
                    comment: item.comment,
                    replyModel: item.commentReply,
                }
            };
            this.modalService.showCustom(modalOptions)
                .then((reply: string) => {
                    item.commentReply = reply;
                    this.saveReply({rating: item});
                });
        }
    }

    angular.module('meevo.plugins.ratingsControlPanel')
        .component('meevoRatingsControlPanelDetailedViewComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/ratingsControlPanel/components/detailedView/ratings-detailed-view.template.html',
            controller: RatingsDetailedViewController,
            controllerAs: '$ctrl',
            bindings: {
                items: '<',
                clientSecurity: '=',
                commentSecurity: '=',
                showClientDetail: '&',
                switchDeleted: '&',
                saveReply: '&',
                isShowSelectColumn: '=',
                selectedClient: '<',
            }
        });
}
